import { Expose, Type } from 'class-transformer';

export enum TimezoneEnum {
  '+07:00' = 'Asia/Jakarta',
}
export class getEnumsInput {
  class: string;
}

export class EnumResult {
  label: string;
  value: string;
}

export enum OtpEnum {
  Register = 'register',
  ResetPassword = 'reset_password',
  ChangeEmail = 'change_email',
}

export enum PassengerIdentifierTypeEnum {
  NationalId = 'national_id',
  Passport = 'passport',
  DriverLicense = 'driver_license',
  FamilyCard = 'family_card',
}
export enum VehicleIdentifierTypeEnum {
  PoliceNumber = 'police_number',
}

export enum GenderEnum {
  Male = 'male',
  Female = 'female',
}

export enum ColumnEnum {
  string = 'string',
  number = 'number',
  integer = 'integer',
  date = 'date',
  nested = 'nested',
}

export class ColumnReport {
  name: string;
  label: string;
  type: ColumnEnum;
  columns?: ColumnReport[];
}

export class NotificationBadges {
  @Expose({ name: 'instant_transaction_count' })
  @Type(() => Number)
  instantTransactionCount: number;

  @Expose({ name: 'promotion_release_count' })
  @Type(() => Number)
  promotionReleaseCount: number;

  @Expose({ name: 'bonus_release_count' })
  @Type(() => Number)
  bonusReleaseCount: number;
}

export class VerifyOtpResult {
  message: string;

  @Expose({ name: 'verification_token' })
  verificationToken: string;
}

export class SendOtpMutationInput {
  type: OtpEnum;
  email: string;
}

export class VerifyOtpMutationInput {
  type: OtpEnum;
  email: string;
  otp: string;
}
